// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"e159c525","121":"7d488b39"}[chunkId] + ".chunk.js";
};